export const BRANDS = [
  {
    name: 'wwd',
    width: 150,
  },
  {
    name: 'glossy',
    width: 210,
  },
  {
    name: 'tc',
    width: 90,
  },
  {
    name: 'forbes',
    width: 210,
  },
]
